import React, { useState, useEffect } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import image1 from "../Assets/Questions/mountain.png";
import image2 from "../Assets/Questions/soil.png";
import image3 from "../Assets/Questions/sun.png";
import image4 from "../Assets/Questions/candle_flame.png";
import image5 from "../Assets/Questions/Axe.png";
import image6 from "../Assets/Questions/jewellery.png";
import image7 from "../Assets/Questions/The_tree.png";
import image8 from "../Assets/Questions/The_Flower.png";
import image9 from "../Assets/Questions/Ocean.png";
import image10 from "../Assets/Questions/rain_water.png";
import { useNavigate } from "react-router-dom";

const ElementFinder = () => {
  const [month, setMonth] = useState("May");
  const [day, setDay] = useState("21");
  const [year, setYear] = useState("2000");
  const [showModal, setShowModal] = useState(false);
  const [matchedResult, setMatchedResult] = useState(null);
  const navigate = useNavigate(); // already imported
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Add VisitorPage states
  const [showTestModal, setShowTestModal] = useState(false);
  const [testStep, setTestStep] = useState(1);
  const [testName, setTestName] = useState("");
  const [testBirthDate, setTestBirthDate] = useState();
  const [testBirthTime, setTestBirthTime] = useState();
  const [testDontKnowTime, setTestDontKnowTime] = useState(false);
  const [testCity, setTestCity] = useState("");
  const [testEmail, setTestEmail] = useState("");
  const [testSendUpdates, setTestSendUpdates] = useState(false);
  const [testSTEM_RELATION, setTestSTEM_RELATION] = useState("");
  const [testImageResult, setTestImageResult] = useState();
  const [testFinalResult, setTestFinalResult] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  // const handleNavigate = () => {
  //   navigate("/visitor"); // change '/test' to your actual route
  // };

  const handleNavigate = () => {
    setShowTestModal(true);
    setTestStep(1); // Reset to first step
  };

  const handleCloseTestModal = () => {
    setShowTestModal(false);
    // Reset all test states
    setTestStep(1);
    setTestName("");
    setTestBirthDate();
    setTestBirthTime();
    setTestDontKnowTime(false);
    setTestCity("");
    setTestEmail("");
    setTestSendUpdates(false);
    setTestSTEM_RELATION("");
    setTestImageResult();
    setTestFinalResult(null);
  };

  const handleTestNext = () => {
    if (testStep === 1 && testName.trim() === "") {
      alert("Please enter your name!");
      return;
    } else if (!testBirthDate) {
      alert("Please enter birth date!");
      return;
    }
    setTestStep(testStep + 1);
  };

  const handleTestChoice = (label) => {
    if (!testSTEM_RELATION) {
      console.error("STEM_RELATION is not set!");
      return;
    }

    const stemRelation = testSTEM_RELATION.trim();
    const result = resultMappings.find((item) => item.stem.trim() === stemRelation);
    setTestFinalResult(result || resultMappings[0]);
    setTestStep(3);
  };

  const fetchLunarHeavenlyStems = () => {
    if (!testBirthDate) return;
    
    const datePart = new Date(testBirthDate);
    const [hours, minutes] = (testBirthTime || "00:00").split(":");

    const cYear = datePart.getFullYear();
    const cMonth = datePart.getMonth() + 1;
    const cDay = datePart.getDate();
    const cTime = `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;

    const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${cYear}&cMonth=${cMonth}&cDay=${cDay}&cTime=${cTime}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          const firstItem = data[0];
          const relation = firstItem.STEM_RELATION?.trim();
          setTestSTEM_RELATION(relation);

          const matchedResult = resultMappings.find((entry) => entry.stem.trim() === relation);
          if (matchedResult) {
            setTestImageResult(matchedResult.image);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching Lunar Heavenly Stems:", error);
      });
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      overflow: "auto",
    },
    modal: {
      background: "radial-gradient(circle,rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
      borderRadius: "12px",
      padding: "30px", // Increased padding from 20px to 30px
      maxWidth: isMobile ? "95%" : "900px", // Even larger for desktop
      maxHeight: "95vh",
      overflow: "auto",
      position: "relative",
      color: "#DFBD69",
      width: isMobile ? "95%" : "auto",
      minHeight: "400px", // Add minimum height
      // backgroundColor: "green"
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "none",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
      color: "white",
    },
    formGroup: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "10px",
      marginBottom: "15px",
    },
    checkboxGroup: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      marginBottom: "15px",
    },
    button: {
      padding: "10px 20px",
      border: "none",
      background: "linear-gradient(to right, #DFBD69, #b7954d, #926F34)",
      color: "black",
      borderRadius: "5px",
      cursor: "pointer",
      width: "100%",
    },
    choiceButton: {
      padding: "10px",
      border: "1px solid #DFBD69",
      background: "linear-gradient(to right, #DFBD69, #b7954d, #926F34)",
      color: "black",
      borderRadius: "5px",
      cursor: "pointer",
      width: "100%",
      marginTop: "10px",
    },
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
  const years = Array.from({ length: 2025 - 1935 + 1 }, (_, i) =>
    (1935 + i).toString()
  );

  const elements = [
    "The Jewellery",
    "The Mountain",
    "The Tree",
    "The Flower",
    "The Ocean",
    "The Rain Water",
    "The Soil",
    "The Candle Flame",
    "The Axe",
    "The Sun",
  ];

  const elementImages = [
    image6,
    image1,
    image7,
    image8,
    image9,
    image10,
    image2,
    image4,
    image5,
    image3,
  ];

  const resultMappings = [
    {
      title: "The Mountain",
      stem: "Mountain  ",
      image: image1,
      strength: "Creative, idealistic, and introspective.",
      weakness: "Sometimes detached from reality and overly sensitive.",
      summary:
        "You have a deep inner world and a vivid imagination.\nYou thrive in environments that allow for self-expression and creativity.",
    },
    {
      title: "The Soil",
      stem: "Soil      ",
      image: image2,
      strength:
        "As grounded as a lump of soil on the ground.\nAccommodating peacemaker",
      weakness:
        "Overly cautious and doubtful lives in a cave, unaware of trends",
      summary:
        "Can The Soil get his head out of the ground?\n- The Star\nHard on the outside, but soft on the inside, am I talking about an egg or The Soil?\n- The Axe",
    },
    {
      title: "The Sun",
      stem: "Sun       ",
      image: image3,
      strength:
        "You shine as bright as...the Sun. Of course.\nYou are a shining source of fun and adventures",
      weakness:
        "Your temper is as explosive as the sun is hot.\nMay be confrontational",
      summary:
        "Wow is he always on fire!\n- The Tree\nHave I told you how hot you are today? Oh? I said it three times already? But The Sun is hot.\n- The Flower",
    },
    {
      title: "The Candle Flame",
      stem: "Candle Flame      ",
      image: image4,
      strength:
        "You are a superstar, a money star, good with numbers\nConfident and driven",
      weakness: "Competitive risk-taker\nMay be unstable and anxious",
      summary:
        "Is that a bird, is that a plane, that’s a shooting star!\n- The Soil\nStop blinking, twinkling so much so I can see you clearly!\n- The Sun",
    },
    {
      title: "The Axe",
      stem: "Axe       ",
      image: image5,
      strength: "Decisive, chop chop gotta go.\nHonest and analytical",
      weakness:
        "Unwilling to bury the hatchet.\nHeart and logic as cold as steel.",
      summary:
        "He chops challenges like he chops my wood!\n- The Tree\nHe always looks like he has an axe to grind.\n- The Mountain",
    },
    {
      title: "The Jewellery",
      image: image6,
      stem: "Jewellery     ",
      strength: "Sharpest knife in the kitchen!\nCuts straight to the point",
      weakness: "Can be very direct.",
      summary:
        "They say metal reflects light, but really, he deflects my point\n- The Sun",
    },
    {
      title: "The Tree",
      image: image7,
      stem: "Large Tree",
      strength: "You provide shelter to all who come to you.\nYou don’t judge.",
      weakness:
        "You are stubbornly rooted.\nYou can’t see the forest for the trees.",
      summary:
        "The Tree is so tall and inspiring! Yet speaks so gentle and soothing\n- The Flower\nWhy are they so greedy for my sunlight?\n- The Sun",
    },
    {
      title: "The Flower",
      image: image8,
      stem: "Flowers   ",
      strength: "You are caring and helpful\nYou are nurturing and empathetic",
      weakness:
        "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary:
        "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Ocean",
      stem: "Ocean     ",
      image: image9,
      strength: "Something good about rain clouds here.",
      weakness:
        "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary:
        "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Rain Water",
      stem: "Rain Water     ",
      image: image10,
      strength: "Something good about rain clouds here.",
      weakness:
        "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary:
        "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
  ];

  const handleTestClick = async () => {
    const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=08:30`;

    try {
      // Fetch API data using the built-in fetch API
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Failed to fetch data from API");
      }

      const data = await response.json(); // Parse the JSON response

      // Log the response to understand its structure
      console.log("API response:", data);

      // Ensure STEM_RELATION exists before trying to trim it
      const stemRelation = data[0]?.STEM_RELATION?.trim(); // Access the first object in the array

      if (!stemRelation) {
        throw new Error(
          "STEM_RELATION is missing or invalid in the API response"
        );
      }

      // Find the matching result from resultMappings
      const result = resultMappings.find((r) => r.stem.trim() === stemRelation);

      // Set matched result and show modal
      if (result) {
        setMatchedResult(result);
        setShowModal(true);
      } else {
        console.error(
          "No matching result found for STEM_RELATION:",
          stemRelation
        );
      }
    } catch (error) {
      console.error("Error fetching API:", error);
      console.log(url);
    }
  };

  const styles = {
    container: {
      width: "100%",
      height: "100%",
      maxHeight: "100%",
      boxSizing: "border-box",
      backgroundColor: "transparent",
      color: "#DFBD69",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // justifyContent: "flex-start",
      padding: isMobile ? "1rem" : "1.5rem",
      overflow: "auto",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(5, 1fr)",
      gap: isMobile ? "1rem" : "2rem",
      marginBottom: isMobile ? "1.5rem" : "3rem",
      width: "100%",
      maxWidth: "800px",
      // backgroundColor: "lightblue",
      marginTop: isMobile ? "0" : "2rem",
    },
    item: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: isMobile ? "0.5rem" : "0",
      // backgroundColor: "red"
    },
    imageBox: {
      width: isMobile ? "120px" : "80px",
      height: isMobile ? "120px" : "80px",
      backgroundColor: "#2d2d2d",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
    },
    label: {
      marginTop: "0.5rem",
      textAlign: "center",
      fontSize: isMobile ? "0.9rem" : "1rem",
    },
    title: {
      fontSize: isMobile ? "1.2rem" : "1.5rem",
      fontWeight: "bold",
      marginBottom: isMobile ? "0.5rem" : "1rem",
    },
    formRow: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      gap: isMobile ? "0.5rem" : "1rem",
      alignItems: "center",
      width: isMobile ? "100%" : "auto",
      maxWidth: isMobile ? "300px" : "none",
    },
    select: {
      backgroundColor: "black",
      border: "2px solid #DFBD69",
      color: "#DFBD69",
      padding: "0.5rem",
      borderRadius: "0.375rem",
      width: isMobile ? "100%" : "auto",
    },
    button: {
      backgroundColor: "black",
      border: "2px solid #DFBD69",
      color: "#DFBD69",
      padding: "0.5rem 1rem",
      borderRadius: "0.375rem",
      cursor: "pointer",
      width: isMobile ? "100%" : "auto",
      marginTop: isMobile ? "0.5rem" : "0",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        {elements.map((element, index) => (
          <div key={index} style={styles.item}>
            <div style={styles.imageBox}>
              <img
                src={elementImages[index]}
                alt={element}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </div>
            <div style={styles.label}>{element}</div>
          </div>
        ))}
      </div>

      <h2 style={styles.title}>Find Your Element</h2>

      <div style={styles.formRow}>
        <select
          style={styles.select}
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        >
          {months.map((m, i) => (
            <option key={i} value={i + 1}>
              {m}
            </option>
          ))}
        </select>

        <select
          style={styles.select}
          value={day}
          onChange={(e) => setDay(e.target.value)}
        >
          {days.map((d, i) => (
            <option key={i} value={d}>
              {d}
            </option>
          ))}
        </select>

        <select
          style={styles.select}
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          {years.map((y, i) => (
            <option key={i} value={y}>
              {y}
            </option>
          ))}
        </select>

        <button
          onClick={handleTestClick}
          style={styles.button}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#DFBD69";
            e.target.style.color = "black";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "black";
            e.target.style.color = "#DFBD69";
          }}
        >
          Check your Element
        </button>
      </div>

      {/* <button
        onClick={handleNavigate}
        style={{ 
          ...styles.button, 
          marginTop: isMobile ? "1rem" : "3%",
          width: isMobile ? "100%" : "auto",
          maxWidth: isMobile ? "300px" : "auto",
          padding: "0.5rem 1rem",
          fontSize: isMobile ? "1rem" : "1rem"
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = "#DFBD69";
          e.target.style.color = "black";
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = "black";
          e.target.style.color = "#DFBD69";
        }}
      >
        Take a Test
      </button> */}

      {/* Test Modal */}
      {showTestModal && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <button 
              style={modalStyles.closeButton}
              onClick={handleCloseTestModal}
            >
              ×
            </button>

            {testStep === 1 && (
              <div>
                <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Personal Information</h2>
                
                <div style={modalStyles.formGroup}>
                  <label>My Name is:</label>
                  <input
                    type="text"
                    value={testName}
                    onChange={(e) => setTestName(e.target.value)}
                  />
                </div>

                <div style={modalStyles.formGroup}>
                  <label>I was born on:</label>
                  <DatePicker
                    selected={testBirthDate ? new Date(testBirthDate) : null}
                    onChange={(date) => {
                      const localDate = date.toLocaleDateString("en-CA");
                      setTestBirthDate(localDate);
                      fetchLunarHeavenlyStems();
                    }}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select date"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    maxDate={new Date()}
                  />
                </div>

                <div style={modalStyles.formGroup}>
                  <label>At Birth time:</label>
                  <input
                    type="time"
                    value={testBirthTime}
                    onChange={(e) => {
                      setTestBirthTime(e.target.value);
                      fetchLunarHeavenlyStems();
                    }}
                    disabled={testDontKnowTime}
                  />
                </div>

                <div style={modalStyles.checkboxGroup}>
                  <input
                    type="checkbox"
                    checked={testDontKnowTime}
                    onChange={(e) => {
                      setTestDontKnowTime(e.target.checked);
                      if (e.target.checked) setTestBirthTime("00:00");
                      fetchLunarHeavenlyStems();
                    }}
                  />
                  <label>I don't know my birth time</label>
                </div>

                <div style={modalStyles.formGroup}>
                  <label>In:</label>
                  <select value={testCity} onChange={(e) => setTestCity(e.target.value)}>
                    <option value="">Select your city</option>
                    <option value="New York">New York</option>
                    <option value="London">London</option>
                    <option value="Tokyo">Tokyo</option>
                    <option value="Sydney">Sydney</option>
                  </select>
                </div>

                <div style={modalStyles.formGroup}>
                  <label>My email is:</label>
                  <input
                    type="email"
                    value={testEmail}
                    onChange={(e) => setTestEmail(e.target.value)}
                  />
                </div>

                <div style={modalStyles.checkboxGroup}>
                  <input
                    type="checkbox"
                    checked={testSendUpdates}
                    onChange={(e) => setTestSendUpdates(e.target.checked)}
                  />
                  <label>Send me feng shui updates</label>
                </div>

                <button style={modalStyles.button} onClick={handleTestNext}>
                  Start the test
                </button>
              </div>
            )}

            {testStep === 2 && (
              <div style={{ textAlign: "center" }}>
                <h1>Question 1:</h1>
                <p style={{ fontSize: "18px" }}>
                  You encounter a fairy and she offers you four cards of Fate to choose from:
                </p>
                {testImageResult && (
                  <img
                    src={testImageResult}
                    alt="question"
                    style={{ width: "200px", height: "auto", margin: "20px 0" }}
                  />
                )}
                <div>
                  {["Money", "Wisdom", "Love", "Health"].map((choice) => (
                    <button
                      key={choice}
                      style={modalStyles.choiceButton}
                      onClick={() => handleTestChoice(choice)}
                    >
                      {choice}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {testStep === 3 && testFinalResult && (
              <div style={{ textAlign: "center" }}>
                <div style={{
                  background: "radial-gradient(circle,rgba(183, 149, 77, 1) 0%, rgba(223, 189, 105, 1) 50%, rgba(183, 149, 77, 1) 90%)",
                  color: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  marginBottom: "10px"
                }}>
                  <h2>Congratulations, you are:</h2>
                  <h1>{testFinalResult.title}</h1>
                </div>

                <img
                  src={testFinalResult.image}
                  alt="Result"
                  style={{
                    width: "250px",
                    height: "250px",
                    objectFit: "contain",
                    borderRadius: "12px",
                    margin: "10px 0"
                  }}
                />

                <div style={{
                  background: "radial-gradient(circle,rgba(183, 149, 77, 1) 0%, rgba(223, 189, 105, 1) 50%, rgba(183, 149, 77, 1) 90%)",
                  color: "white",
                  borderRadius: "10px",
                  padding: "16px",
                  marginBottom: "20px",
                  textAlign: "center"
                }}>
                  <h3>Strengths</h3>
                  <p>{testFinalResult.strength}</p>
                  <h3>Weaknesses</h3>
                  <p>{testFinalResult.weakness}</p>
                </div>

                <div style={{
                  background: "radial-gradient(circle,rgba(183, 149, 77, 1) 0%, rgba(223, 189, 105, 1) 50%, rgba(183, 149, 77, 1) 90%)",
                  color: "white",
                  borderRadius: "10px",
                  padding: "16px"
                }}>
                  <h3>What your friends may say about you:</h3>
                  <p style={{ fontStyle: "italic", whiteSpace: "pre-wrap" }}>
                    {testFinalResult.summary}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showModal && matchedResult && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "black",
              border: "2px solid #DFBD69",
              borderRadius: "1rem",
              padding: "2rem",
              maxWidth: "500px",
              color: "#DFBD69",
              textAlign: "center",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>{matchedResult.title}</h2>
            <img
              src={matchedResult.image}
              alt={matchedResult.title}
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <p>
              <strong>Strength:</strong> {matchedResult.strength}
            </p>
            <p>
              <strong>Weakness:</strong> {matchedResult.weakness}
            </p>
            <p
              style={{
                fontStyle: "italic",
                marginTop: "1rem",
                whiteSpace: "pre-wrap",
              }}
            >
              {matchedResult.summary}
            </p>
            <p style={{ marginTop: "1rem" }}></p>
            <p></p>
            <p
              style={{
                fontStyle: "italic",
                marginTop: "1rem",
                whiteSpace: "pre-wrap",
              }}
            ></p>
            <button
              onClick={() => setShowModal(false)}
              style={{
                marginTop: "1.5rem",
                backgroundColor: "black",
                border: "2px solid ",
                color: "#DFBD69",
                padding: "0.5rem 1rem",
                borderRadius: "0.375rem",
                cursor: "pointer",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#DFBD69";
                e.target.style.color = "black";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "black";
                e.target.style.color = "#DFBD69";
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ElementFinder;
